module.exports = __webpack_public_path__ + "img/404.6d6584f.webp";